import { createSlice } from '@reduxjs/toolkit'
import { getModesData } from './modeDataActions'

const initialState = {
  modesData: {},
  loading: false,
  loadingError: false,
  loaded: false,
}

/*function isRejectedAction(action) {
  return action.type.endsWith('rejected')
}*/

const modesDataSlice = createSlice({
  name: 'modesdata',
  initialState,
  reducers: {
    clear: (state) => {
      state.loading = false
      state.loadingError = false
      state.loaded = false
    },
  },

  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(getModesData.fulfilled, (state, { payload }) => {
        state.loading = false
        state.loaded = true
        state.loadingError = null
        state.modesData = payload
      })
      .addCase(getModesData.pending, (state) => {
        state.loading = true
        state.loaded = false
        state.loadingError = null
      })
      .addCase(getModesData.rejected, (state, { payload }) => {
        state.loading = false
        state.loaded = false
        state.loadingError = payload
      })
  },
})

export const { clear } = modesDataSlice.actions
export default modesDataSlice.reducer
